import { Component, Input } from '@angular/core';

export type SeverityLevel = 'high' | 'medium' | 'low';

@Component({
  selector: 'app-severity',
  templateUrl: './severity.component.html',
  styleUrls: ['./severity.component.scss']
})
export class Severity {
  @Input() severityLevel: SeverityLevel = 'low';
  @Input() text: string = '';
  @Input() reverseColors: boolean = false; // For Project Synapse where low = bad (red), high = good (green)

  getEffectiveSeverityClass(): string {
    if (!this.reverseColors) {
      return this.severityLevel;
    }

    // For Project Synapse: reverse the color mapping
    // low discrepancy (similarity to AI) = bad = red (high class)
    // high discrepancy (different from AI) = good = green (low class)
    switch (this.severityLevel) {
      case 'low':
        return 'high'; // low similarity to AI = bad = red
      case 'high':
        return 'low';  // high similarity to AI = good = green
      case 'medium':
        return 'medium'; // medium stays medium
      default:
        return this.severityLevel;
    }
  }
}

